import AsmRuntime from "./AsmRuntime";
import { Drive } from "../fs";
import { handler } from "../util/URLHandler";
import { WasmExports } from "./AsmRuntime";

export default class PWSM extends AsmRuntime {
    constructor(path: string, cmdLine: string, env: { [key: string]: string }, flags?: { [key: string]: boolean }) {
        super(path, cmdLine, env, flags);
    }

    async exec() {
        const fileNoDrive = this.path.slice(3);
        const file = await Drive.getByDriveLetter("C")?.driverInstance?.read(fileNoDrive);

        // Error handling
        if (!file || file instanceof Error) throw new Error("File not found");

        this.state = "running";
        try {
            this.wasmBytes = new Uint8Array(await file.arrayBuffer());
            
            // Skip the host bindings file and use direct WebAssembly instantiation
            // with our simplified import object from AsmRuntime
            const { instance } = await WebAssembly.instantiate(this.wasmBytes, this.importObject);
            this.wasmInstance = instance;
            this.exports = instance.exports as WasmExports;
            
            // Call the start function if it exists
            if (typeof this.exports._start === 'function') {
                const result = this.exports._start();
                console.log(`[PWSM] WASM module started, returned: ${result}`);
            } else {
                console.error(`[PWSM] WASM module has no _start function`);
            }
        } catch (e) {
            console.error(`[AssemblyRuntime] Error running WASM module: ${e}`);
            this.terminate();
            throw e
        }
    }

    terminate(): void {
        super.terminate();
        // No blob URL to revoke since we're not using host bindings
    }
}